import {
    CompanyAction,
    CompanyActionTypes
} from "interfaces/context/appContextInterfaces";
import { ORMSingleCompany } from "interfaces/api/apiInterfaces";

export const companyReducer = (state: ORMSingleCompany, action: CompanyAction) => {
    switch (action.type) {
    case CompanyActionTypes.updateCompany: {
        const updatedState = {
            ...state,
            ...action.payload
        };
        return updatedState;
    }
    case CompanyActionTypes.resetCompany: {
        return null;
    }
    default: {
        return state;
    }
    }
};
